import { FormGroup, FormControl, ValidationErrors } from "@angular/forms";

export class SamplingReportFormGroup extends FormGroup {
    constructor() {
        super({
            plantingDateRange: new FormControl(null),
            samplingDateRange: new FormControl(null) ,
            crop: new FormControl(),
            laboratory: new FormControl(),
            laboratoryAssay: new FormControl(),
            growthStage: new FormControl()
        },
        {
            validators: SamplingReportFormGroup.SamplingReportFormGroupValidator
        });
    }

    public get plantingDateRangeFormControl(): FormControl {
        return <FormControl> this.get('plantingDateRange');
    }

    public get samplingDateRangeFormControl(): FormControl {
        return <FormControl> this.get('samplingDateRange');
    }

    public get cropFormControl(): FormControl {
        return <FormControl> this.get('crop');
    }

    public get laboratoryFormControl(): FormControl {
        return <FormControl> this.get('laboratory');
    }

    public get laboratoryAssayFormControl(): FormControl {
        return <FormControl> this.get('laboratoryAssay');
    }

    public get growthStageFormControl(): FormControl {
        return <FormControl> this.get('growthStage');
    }

    static SamplingReportFormGroupValidator(formGroup: SamplingReportFormGroup): ValidationErrors | null {
        const plantingDateRangeControl = formGroup.plantingDateRangeFormControl;
        const samplingDateRangeControl = formGroup.samplingDateRangeFormControl;

        const plantingDateRange = <Date[]> plantingDateRangeControl.value;
        const samplingDateRange = <Date[]> samplingDateRangeControl.value;

        if ((plantingDateRange && plantingDateRange.length > 1) || (samplingDateRange  && samplingDateRange.length > 1)) {
            return null;
        }
        
        return {
            plantingDateRangeInvalid: true,
            samplingDateRangeInvalid: true
        };;
    }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/sampling-report-form/sampling-report-form-group.ts